// ANCHOR React
import { useState } from 'react';

// ANCHOR Base
import { Block } from 'baseui/block';
import { LabelLarge, LabelSmall, LabelXSmall } from 'baseui/typography';
import { Button } from 'baseui/button';

// ANCHOR React Icons
import { Icon } from 'react-icons-kit';
import { ic_delete as Delete } from 'react-icons-kit/md/ic_delete';
import { check } from 'react-icons-kit/fa/check';
import { times } from 'react-icons-kit/fa/times';

// ANCHOR API
import { deleteFormQuestionAnswerById } from '@lyon/utils/api/forms';
import { IFormQuestionAnswersResult } from '@lyon/utils/api/results/forms';

// ANCHOR Models
import { useFormQuestionAnswersMutate } from '@lyon/scoped-models/form/FormQuestionAnswersData';
import { useFormDataType } from '@lyon/scoped-models/form/FormData';

// ANCHOR Hooks
import { usePromise } from '@lyon/utils/hooks/usePromise';
import { useSentryExceptionHandler } from '@lyon/utils/hooks/useSentryExceptionHandler';

// ANCHOR Graph State
import { useAuthToken } from '@lyon/nodes/firebase/auth/auth-token-node';

// ANCHOR Styles
import {
  NAME, BLOCK, ICON, DELETE, POINTS,
} from './styles';

interface IProps {
  answer: IFormQuestionAnswersResult;
  prefix: string;
}

export function LyonUpdateCheckboxAnswerListItem(
  { answer, prefix }: IProps,
) {
  const token = useAuthToken();
  const catchException = useSentryExceptionHandler();
  const mutate = useFormQuestionAnswersMutate();
  const formType = useFormDataType();

  const [loading, setLoading] = useState(false);

  const mounted = usePromise([token, answer]);

  const onClick = async () => {
    setLoading(true);

    try {
      if (token) {
        await mounted(deleteFormQuestionAnswerById({
          token,
          id: answer.id,
        }));

        await mounted(mutate());
      }
    } catch (error) {
      catchException(error);
    }

    setLoading(false);
  };

  return (
    <Block overrides={BLOCK}>
      <Block display="flex" alignItems="center">
        {
          formType === 'quiz' && (
            <LabelSmall overrides={answer.points ? ICON : DELETE} marginRight="16px">
              <Icon size={20} icon={answer.points ? check : times} />
            </LabelSmall>
          )
        }
        <LabelLarge overrides={NAME}>
          {`${prefix}: ${answer.name}`}
        </LabelLarge>
        <LabelXSmall overrides={POINTS}>
          {`${answer.points} points`}
        </LabelXSmall>
      </Block>
      <Button
        type="button"
        kind="tertiary"
        size="compact"
        onClick={onClick}
        isLoading={loading}
      >
        <LabelSmall overrides={DELETE}>
          <Icon size={20} icon={Delete} />
        </LabelSmall>
      </Button>
    </Block>
  );
}
